import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=55557af0"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=55557af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports